import React from 'react';
import classNames from 'classnames';
import { classes } from './field-label-wut.st.css';
import { RequiredIndicator, RequiredIndicatorPlacement as Placement, ImagePosition } from '@wix/ambassador-forms-v4-form/types';
import { useTranslation } from '../../contexts/translation-context';
import { ImageFit, ImageAlignment } from '../../types/image';
import { ImageComponentWUT } from '../image-choice-field/image-component-wut';
const DEFAULT_IMAGE_ASPECT_RATIO = 3 / 2;
export const FieldLabelWUT = _ref => {
  let {
    labelId,
    htmlFor,
    label,
    required = false,
    hideLabel = false,
    requiredIndicatorHidden = false,
    requiredIndicatorType = RequiredIndicator.ASTERISK,
    requiredIndicatorPlacement = Placement.AFTER_FIELD_TITLE,
    media,
    mediaSettings
  } = _ref;
  const Tag = htmlFor ? 'label' : 'div';
  const {
    t
  } = useTranslation();
  const {
    imagePosition = ImagePosition.ABOVE,
    imageFit = ImageFit.COVER,
    imageAlignment = ImageAlignment.CENTER
  } = media ? mediaSettings ?? {} : {};
  const labelAfterRequiredIndicator = requiredIndicatorType === RequiredIndicator.ASTERISK && requiredIndicatorPlacement === Placement.BEFORE_FIELD_TITLE;
  const imageElement = media ? /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.imageContainer, {
      [classes.imageContainerAbove]: imagePosition === ImagePosition.ABOVE,
      [classes.imageContainerBelow]: imagePosition === ImagePosition.BELOW
    })
  }, /*#__PURE__*/React.createElement(ImageComponentWUT, {
    image: media,
    aspectRatio: DEFAULT_IMAGE_ASPECT_RATIO,
    imageAlignment: imageAlignment,
    imageResize: imageFit
  })) : null;
  const labelElement = /*#__PURE__*/React.createElement(Tag, {
    id: labelId,
    htmlFor: htmlFor,
    className: classNames(classes.label, {
      [classes.labelWithImage]: media,
      [classes.hidden]: hideLabel
    })
  }, !labelAfterRequiredIndicator && label, required && !requiredIndicatorHidden && /*#__PURE__*/React.createElement(React.Fragment, null, requiredIndicatorType === RequiredIndicator.ASTERISK && /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: labelAfterRequiredIndicator ? classes.indicatorBeforeLabel : classes.indicatorAfterLabel
  }, "*"), requiredIndicatorType === RequiredIndicator.TEXT && /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    className: classes.indicatorAfterLabel
  }, t('settings.required-indicator-text'))), labelAfterRequiredIndicator && label);
  if (!media) {
    return labelElement;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.labelWithImageContainer
  }, imagePosition === ImagePosition.ABOVE ? imageElement : null, labelElement, imagePosition === ImagePosition.BELOW ? imageElement : null);
};
//# sourceMappingURL=field-label-wut.js.map